module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sidebar d-flex align-items-end relative alt"
  }, [_c('img', {
    staticClass: "smallLogo",
    attrs: {
      "src": "/static/images/common/logo_small_red_white.svg"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "img-fluid",
    attrs: {
      "src": "/static/images/auth/signup.jpg"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "text text-left"
  }, [_c('div', {
    staticClass: "fs-largest lightest headline"
  }, [_c('b', [_vm._v("Hey " + _vm._s(_vm.name) + "!")]), _c('br'), _vm._v("Let us know about yourself.")])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-7fb0f349", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7fb0f349"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/auth/sidebars/CreateSidebar.vue
// module id = 1228
// module chunks = 0